import React from 'react';

import { Filter } from './search_filters';
import RegionFilterOptions from './region_filter_options';
import { IUserContext, withUserContext } from './user_context_provider';

interface IProps extends IUserContext {
  filter: Filter; // filter with selected region only
  trackingQuery?: string;
}

export class RegionSelectFilter extends React.Component<IProps, null> {
  renderFilterOptions() {
    return (
      <RegionFilterOptions
        placeholderFilter={this.props.filter}
        trackingQuery={this.props.trackingQuery}
      />
    );
  }

  render() {
    return (
      <div className="facet">
        <div className="facet__heading">
          {this.props.filter.name}
        </div>
        {this.renderFilterOptions()}
      </div>
    );
  }
}

export default withUserContext(RegionSelectFilter);
